<template>
  <div class="">
    <Form ref="tournamentForm" :model="tournamentForm" :rules="tournamentRules">
      <FormItem prop="TournamentName">
        <i-input
                v-model="tournamentForm.TournamentName"
                type="text"
                placeholder="Tournament Name"
        ></i-input>
      </FormItem>
      <FormItem prop="Description">
        <Select v-model="language" filterable placeholder="Select language" style="width: 200px;margin-bottom: 8px;" class="right capitalize">
          <Option v-for="lang in UIlanguages" :value="lang.LanguageCode" :key="lang.LanguageCode" class="capitalize">{{ lang.LanguageName}}</Option>
        </Select>
        <Input v-model="description" type="textarea" placeholder="Description" :autosize="{minRows: 5,maxRows: 5}"></Input>
        <Button type="primary" class="right" style="margin-top: 16px;" v-if="description.length" @click="addUpdateDescription('create')" small ghost>Add description</Button>
        <Button type="success" class="right" style="margin-top: 16px;margin-right: 8px" v-if="activeDescription!=null" @click="addUpdateDescription('update')" small ghost>Update description</Button>
      </FormItem>
      <Table :columns="descColumns" :data="descriptionList" :row-class-name="DescRowClassName" ref="descriptionTable" class="white-table" v-if="descriptionList.length" @on-row-click="onDescRowClick" style="margin-bottom: 24px;">
        <div slot-scope="{ row, index }" slot="action">
          <Button type="error" size="small" @click="deleteDescription(index)">Delete</Button>
        </div>
      </Table>
      <Transfer
              :data="trophies"
              :target-keys="tournamentForm.Trophies"
              :list-style="listStyle"
              :render-format="renderName"
              :titles="['Available trophies', 'Added trophies']"
              @on-change="handleTrophiesChange"></Transfer>
    </Form>
    <Row type="flex" justify="center" :gutter="16" style="margin-top: 24px;">
      <i-col :xs="12" v-if="showUpdate">
        <Button long
                type="success"
                :loading="submitUpdateLoading"
                @click="handleCreateOrUpdate('update')"
        >       <span v-if="!submitUpdateLoading">Update tournament</span>
          <span v-else>Processing...</span>
        </Button>
      </i-col>
      <i-col :xs="12">
        <Button long
                type="primary"
                :loading="submitLoading"
                @click="handleCreateOrUpdate('create')"
        >       <span v-if="!submitLoading">Add tournament</span>
          <span v-else>Processing...</span>
        </Button>
      </i-col>
    </Row>
    <Spin size="large" fix v-if="spinShow">
      <Icon type="ios-loading" size=32 class="spin-icon-load"></Icon>
    </Spin>
  </div>

</template>

<script>
  import { bus } from "../../main";
  import { addTournament, updateTournament, getTournament } from "../../_services/tournament.service";
  import { getTrophies } from "../../_services";
  import { getSupportedLanguages } from "../../_services/language.service";

  export default {
    props:['tournaments'],
    data() {
      const validateName = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('Please fill in the tournament name.'));
        } else {
          let duplicateName=this.tournaments.filter(({TournamentName})=>{
            return TournamentName===value
          })
          if(duplicateName.length){
            if(this.tournamentForm._id){
              if(duplicateName.length>1){
                callback(new Error('Tournament name already exist.'));
              }else{
                if(duplicateName[0]._id!==this.tournamentForm._id){
                  callback(new Error('Tournament name already exist.'));
                }else{
                  callback();
                }
              }
            }else{
              callback(new Error('Tournament name already exist.'));
            }
          }else{
            callback();
          }
        }
      };
      const validateDescripton = (rule, value, callback) => {
        if (!this.descriptionList.length) {
          callback(new Error('Please add tournament description.'));
        } else {
          callback();
        }
      };
      return {
        submitUpdateLoading:false,
        submitLoading:false,
        showUpdate:false,
        descColumns: [
          {
            title: "Language",
            key: "LanguageName",
            className: "capitalize",
            width:"150"
          },
          {
            title: "Description",
            key: "Description"
          },
          {
            title:" ",
            slot:"action",
            align:"right",
            width: "80"
          }
        ],
        language:"",
        description:"",
        descriptionList:[],
        activeDescription:null,
        trophies:[],
        tournamentForm:{
          TournamentName: "",
          Description: {},
          Trophies: []
        },
        currentUpdateData:{
          TournamentName: "",
          Description: {},
          Trophies: []
        },
        tournamentRules: {
          TournamentName: [
            { validator: validateName, trigger: 'blur' }
          ],
          Description: [
            { validator: validateDescripton, trigger: 'blur' }
          ],
        },
        listStyle: {
          width: '210px',
          height: '200px'
        },
        UIlanguages:[],
        spinShow:false,
      };
    },
    methods: {
      getUILanguageList() {
        this.dataLoading=true
        getSupportedLanguages().then(res=>{
          this.UIlanguages=res.data.data
          this.language=res.data.data[0].LanguageCode
        }).catch(err=>{
          bus.$emit('requestError',err)
        })
      },
      async addUpdateDescription(method){
        this.activeDescription=null
        let existingLang = this.descriptionList.filter(({LanguageCode}) => {
          return LanguageCode === this.language
        })
        let lang = Object.assign({},this.UIlanguages.filter(({LanguageCode}) => {
          return LanguageCode === this.language
        })[0])
        lang.Description = this.description
        if(method==="create"){
          if(existingLang.length){
            this.$Notice.error({
              title: 'Duplicate Language',
              desc: `Description for language <span class="capitalize">${existingLang[0].LanguageName}</span> already exist.`,
            });
          }else {
            this.descriptionList.push(lang)
            this.language = this.UIlanguages[0].LanguageCode
            this.description = ""
          }
        }else {
          this.descriptionList.splice(this.activeDescription,1,lang)
          this.language = this.UIlanguages[0].LanguageCode
          this.description = ""
        }
        await this.$refs.tournamentForm.validateField('Description');
      },
      deleteDescription(index){
        this.descriptionList.splice(index,1)
        this.$refs.tournamentForm.validateField('Description');
        this.activeDescription=null
      },
      onDescRowClick(data,index){
        if(this.activeDescription===index){
          this.activeDescription=null
        }else {
          this.activeDescription = index
          this.language = data.LanguageCode
          this.description = data.Description
        }
      },
      DescRowClassName(row, index) {
        if (index === this.activeDescription) {
          return 'active-table-row';
        }
        return '';
      },
      setUpdateData(data){
        let vm=this
        vm.spinShow=true
        if(this.currentUpdateData._id){
          vm.spinShow=false
          if(JSON.stringify(this.currentUpdateData)!==JSON.stringify(this.tournamentForm)){
            this.$Modal.confirm({
              title: 'Unsaved Changes',
              content: `Changes made on ${this.currentUpdateData.TournamentName} is not yet saved? Do you wish to save it first?`,
              okText: 'Save',
              cancelText: 'Discard',
              onOk:() => {
                this.handleCreateOrUpdate('update',data)
              },
              onCancel: () =>{
                this.getTournamentData(data)
                this.$emit('setActive',data)
              }
            });
          }else{
            this.getTournamentData(data)
            this.$emit('setActive',data)
          }
        }else {
          this.getTournamentData(data)
          this.$emit('setActive',data)
        }

      },
      getTournamentData(data){
        let vm=this
        vm.resetForm()

        getTournament(data._id).then(async res=>{
          this.showUpdate=true
          let tournamentData = Object.assign({},res.data.data)
          vm.tournamentForm._id=data._id
          vm.tournamentForm.TournamentName=res.data.data.TournamentName
          vm.tournamentForm.Description={}
          vm.tournamentForm.Trophies=tournamentData.trophies.map(trophy=>{return trophy._id})
          Object.keys(tournamentData.Description).forEach(key=>{
            let lang = Object.assign({},this.UIlanguages.filter(({LanguageCode}) => {
              return LanguageCode === key
            })[0])
            lang.Description = tournamentData.Description[key]
            this.descriptionList.push(lang)
            vm.spinShow=false
          })
          this.currentUpdateData = Object.assign({},this.tournamentForm)

        })
      },
      getTrophiesList(){
        getTrophies().then(async res=>{
          this.trophies=res.data.data.map(trophy=>{
            trophy.key=trophy._id
            return trophy
          })
        }).catch(err=>{
          bus.$emit('requestError',err)
        })
      },
      renderName(item){
        return item.TrophyName
      },
      handleTrophiesChange(newTargetKeys, direction, moveKeys) {
        this.tournamentForm.Trophies = newTargetKeys;
      },
      handleCreateOrUpdate(method,nextData) {
        if(method==='create' && this.tournamentForm._id) {
          this.showUpdate=false
          delete this.tournamentForm._id;
          this.$emit('setActive',null);
        }
        this.$refs.tournamentForm.validate(valid => {
          if (valid) {
            this.descriptionList.map(desc=>{
              this.tournamentForm.Description[desc.LanguageCode]=desc.Description
            })

            if(method==='create') {
              this.submitLoading=true
              addTournament(this.tournamentForm).then(res => {
                this.$Message.success(`${this.tournamentForm.TournamentName} added to tournaments!`);
                this.$emit('getTournaments')
                this.submitLoading = false
                this.resetForm()
              }).catch(err => {
                bus.$emit('requestError',err)
                this.submitLoading = false
                this.$Message.error('Failed to create tournament. Please try again later.')
              })
            }else{
              this.submitUpdateLoading=true
              updateTournament(this.tournamentForm._id,this.tournamentForm).then(res => {
                this.$Message.success(`Successfully updated tournament ${this.tournamentForm.TournamentName}!`);
                this.$emit('getTournaments')
                this.submitUpdateLoading = false
                this.currentUpdateData = Object.assign({},res.data.data)
                if(nextData){
                  this.getTournamentData(nextData)
                  this.$emit('setActive',nextData);
                }else {
                  this.$emit('setActive',null);
                  this.resetForm()
                }
              }).catch(err => {
                bus.$emit('requestError',err)
                this.submitUpdateLoading = false
                this.$Message.error('Failed to update tournament. Please try again later.')
              })
            }
          }
        });
      },
      resetForm(){
        this.showUpdate=false
        this.currentUpdateData={}
        this.tournamentForm={
          TournamentName: "",
          Description: {},
          Trophies: []
        }
        this.language=this.UIlanguages[0].LanguageCode
        this.description=""
        this.descriptionList=[]
        this.activeDescription=null
        this.$refs.tournamentForm.resetFields();
      }
    },
    mounted() {
      this.getUILanguageList()
      this.getTrophiesList()
    }
  };
</script>
<style scoped>

</style>
